import axios from 'axios';

// const baseURL = 'http://localhost:5000/api/';
const baseURL = 'http://185.233.186.19/api/';
export const instance = axios.create({
    baseURL,
    withCredentials: true,
    headers: {},
});

instance.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    return config;
});

function updateAccessToken(response) {
    if (response.data.isOkay) {
        const {accessToken} = response.data;
        if (!accessToken) return;
        localStorage.setItem('token', accessToken);
    }
}

const defaultErrorString = 'Произошла неизвестная ошибка';

export const advertAPI = {
    async getRoutes() {
        try {
            const response = await instance.get(`routes`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            console.log(error);
            return {isOkay: false, message: error.message || defaultErrorString}
        }
    },
    async getPromoters() {
        try {
            const response = await instance.get(`promoters`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            console.log(error);
            return {isOkay: false, message: error.message || defaultErrorString}
        }
    },
    async getFinishedRoutes(month, routeId) {
        try {
            const response = await instance.get(`finishedRoutes/${month || 'null'}/${routeId || ''}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            console.log(error);
            return {isOkay: false, message: error.message || defaultErrorString}
        }
    },
    async createPromoter(promData) {
        const formData = new FormData();
        const {files, ...fulteredProm} = promData;
        formData.append('promoter', JSON.stringify(fulteredProm));

        for (let i = 0; i < files.length; i++) {
            formData.append('promDoc', files[i]);
        }
        try {
            const response = await instance.post('promoters', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            });
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },
    async editPromoter(promData) {
        const formData = new FormData();
        const {files, ...fulteredProm} = promData;
        formData.append('promoter', JSON.stringify(fulteredProm));

        for (let i = 0; i < files.length; i++) {
            formData.append('promDoc', files[i]);
        }
        try {
            const response = await instance.put('promoters', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            });
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },
    async deletePromoter(promoterId, isRecovery = false) {
        try {
            const response = await instance.delete(`promoters/${promoterId}${isRecovery ? `/${isRecovery}`:''}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },
    async assignRoute(assignData) {
        try {
            const response = await instance.put(`routes/assign`, assignData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async editActiveRoute(editData) {
        try {
            const response = await instance.put(`routes/edit`, editData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async revokeRoute(routeId) {
        try {
            const response = await instance.delete(`routes/revoke/${routeId}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async takeRouteToCheck(promoterId, routeId, isRevision) {
        try {
            const response = await instance.delete(`routes/takeToCheck/${promoterId}/${routeId}${isRevision ? '/isRevision':''}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async rejectRoutePorch(porchData) {
        try {
            const response = await instance.put(`routes/rejectPorch`, porchData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async checkRouteAddress({promoterId, routeId, houseId, porchId}) {
        try {
            const response = await instance.put(`routes/checkAddress`, {promoterId, routeId, houseId, porchId});
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async deleteRoutePhoto(photoData) {
        const {promoterId, houseId, routeId, fileId} = photoData;
        try {
            const response = await instance.delete(`routes/photo/${promoterId}/${routeId}/${houseId}/${fileId}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async addSpreadFlyers(flyersData) {
        try {
            const response = await instance.post(`routes/addSpreadFlyers`, flyersData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async finishRoute(finishData) {
        try {
            const response = await instance.post(`routes/finish`, finishData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async editFinishedRoute(finishData) {
        try {
            const response = await instance.put(`routes/finish`, finishData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async createFinishedRoute(routeData) {
        try {
            const response = await instance.post(`routes/createFinish`, routeData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async returnFlyers(body) {
        try {
            const response = await instance.put(`routes/returnFlyers`, body);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },

    async checkRoute(finishId) {
        try {
            const response = await instance.delete(`routes/check/${finishId}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async payForRoute(finishId) {
        try {
            const response = await instance.delete(`routes/pay/${finishId}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async setRouteComment(commentData) {
        try {
            const response = await instance.put(`routes/setComment`, commentData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async setRouteLocks(locksData) {
        try {
            const response = await instance.put(`routes/setLocks`, locksData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async editPlan(planData) {
        try {
            const response = await instance.put(`advert/editPlan`, planData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async fetchRouteHistory(routeId) {
        try {
            const response = await instance.get(`advert/routeHistory/${routeId}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    }
}
export const settingsAPI = {
    async getSettings() {
        try {
            const response = await instance.get(`settings`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            console.log(error);
            return {isOkay: false, message: error.message || defaultErrorString}
        }
    },
    async update(settings) {
        try {
            const response = await instance.put(`settings`, settings);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async updateOrderColors(newList) {
        try {
            const response = await instance.put(`settings/update-order-colors`, newList);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async updateThemeColors(newProps) {
        try {
            const response = await instance.put(`settings/update-theme-colors`, newProps);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
}
export const authAPI = {
    async login(login, password) {
        try {
            const response = await instance.post(`login`, { login, password });
            if (response.data.isOkay) {
                localStorage.setItem('token', response.data.accessToken);
            }
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async me() {
        try {
            const response = await instance.get(`me`);
            updateAccessToken(response);
            if (response.data.accessToken) {
                localStorage.setItem('token', response.data.accessToken);
            }
            return response.data;
        } catch (error) {
            console.log(error);  
            return error;
        }
    },
    async logout() {
        try {
            const response = await instance.post(`logout`);
            localStorage.removeItem('token');
            return response.data;
        } catch (error) {
            console.log(error);
            return {isOkay: false, message: error.message || 'Произошла ошибка'}
        }
    },
};

export const officeAPI = {
    async getRevenues(month) {
        try {
            const response = await instance.get(`office/revenues${month ? `/${month}` : ''}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async getExpenses(month) {
        try {
            const response = await instance.get(`office/expenses${month ? `/${month}` : ''}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async getBalances(month) {
        try {
            const response = await instance.get(`office/balances${month ? `/${month}` : ''}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async createRevenue(revenueData) {
        try {
            const response = await instance.post(`office/revenue`, {revenueData});
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async deleteRevenue(revenueId) {
        try {
            const response = await instance.delete(`office/revenue/${revenueId}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async createExpense(expenseData) {
        try {
            const response = await instance.post(`office/expense`, {expenseData});
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async editExpense(expenseData) {
        try {
            const response = await instance.put(`office/expense`, {expenseData});
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async deleteExpense(expenseId) {
        try {
            const response = await instance.delete(`office/expense/${expenseId}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async handOver(orderIds) {
        try {
            const response = await instance.post(`office/handover`, {orderIds});
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async returnOrder(revenueIds) {
        try {
            const response = await instance.post(`office/return`, {revenueIds});
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async createCategory(categoryData) {
        try {
            const response = await instance.post(`office/categories`, {categoryData});
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async editCategory(categoryData) {
        try {
            const response = await instance.put(`office/categories`, {categoryData});
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async deleteCategory(categoryId) {
        try {
            const response = await instance.delete(`office/categories/${categoryId}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async createPromoterExpense(finishId) {
        try {
            const response = await instance.post(`office/promoterExpense`, {finishId});
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
}

export const ordersAPI = {
    async get(month, loadedOrders) {
        const orderIds = loadedOrders.join('_');
        try {
            const response = await instance.get(`/orders/${month}${orderIds ? `/${orderIds}` : ''}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async getDeps(ids) {
        const orderIds = ids.join('_');
        try {
            const response = await instance.get(`/orders/deps/${orderIds}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async getEvents(orderId) {
        try {
            const response = await instance.get(`/orders/events/${orderId}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async create(orderData) {
        try {
            const response = await instance.post(`orders`, orderData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },
    async createDep(orderDepData) {
        try {
            const response = await instance.post(`orders/inherit`, orderDepData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },
    async assign(orderId, userId) {
        try {
            const response = await instance.post(`orders/assign`, {orderId, userId});
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },
    async edit(orderData) {
        try {
            const response = await instance.put(`orders/`, orderData);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },
    async complete(orderData) {
        try {
            const formData = new FormData();
            const filteredOrder = orderData.orderData;
            const {bso, cheque} = filteredOrder;
            delete filteredOrder.bso;
            delete filteredOrder.cheque;

            formData.append('order', JSON.stringify(filteredOrder));
            formData.append('completeType', JSON.stringify(orderData.completeType));

            for (let i = 0; i < bso?.length; i++) {
                formData.append('bso', bso[i]);
            }
            for (let i = 0; i < cheque?.length; i++) {
                formData.append('cheque', cheque[i]);
            }
            const response = await instance.put(`orders/complete`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            });
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },
    async revoke(orderId) {
        try {
            const response = await instance.delete(`orders/revoke/${orderId}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);
            return error.response.data;
        }
    },
    async reset(orderId) {
        try {
            const response = await instance.delete(`orders/reset/${orderId}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },
    async delete(orderId, isRecovery = false) {
        try {
            const response = await instance.delete(`orders/${orderId}${isRecovery ? '/recovery' : ''}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },
    async recovery(orderId) {
        try {
            const response = await instance.delete(`recoveryOrder/${orderId}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            console.log(error);
            return {isOkay: false, message: error.message || defaultErrorString}
        }
    }
};

export const usersAPI = {
    async get() {
        try {
            const response = await instance.get(`users`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            console.log(error);
            return {isOkay: false, message: error.message || defaultErrorString}
        }
    },
    async create(userData) {
        const formData = new FormData();
        const fulteredUser = {
            ...userData,
            personalData: {
                phoneNumber: userData.personalData.phoneNumber,
            }
        }
        formData.append('user', JSON.stringify(fulteredUser));
        const docs = userData.personalData.documents;
        for (let i = 0; i < docs.length; i++) {
            formData.append('userDoc', docs[i]);
        }
        try {
            const response = await instance.post('users', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            });
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },

    async edit(userData) {
        const formData = new FormData();
        const {documents, ...rest} = userData;

        formData.append('user', JSON.stringify(rest));
        for (let i = 0; i < documents.length; i++) {
            formData.append('userDoc', documents[i]);
        }
        try {
            const response = await instance.put('users', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            });
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },

    async delete(userId, deleted) {
        try {
            const response = await instance.delete(`users/${userId}${!deleted ? '/recovery' : ''}`);
            updateAccessToken(response);
            return response.data;
        } catch (error) {
            console.log(error);
            return {isOkay: false, message: error.message || defaultErrorString}
        }
    },

}
export const staticAPI = {
    async getImage(type, fileName) {
        try {
            const response = await instance.get(`photos/${type}/${fileName}`, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            console.log(error);
            return {isOkay: false, message: error.message || defaultErrorString}
        }
    },
    async getRouteContent(id, type, promoterId, routeId) {
        try {
            const url = `${baseURL}/routes/media/${id}/${type}/${promoterId}/${routeId}`;
            const isVideo = type === 'promHouseVideo';
            let response = null;
            if (isVideo) {
                response = await fetch(url, {
                    headers: {
                        'Range': 'bytes=0-',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
            } else {
                response = await fetch(url, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
            }
            return response;
        } catch (error) {
            console.log(error);
            return {isOkay: false, message: error.message || defaultErrorString}
        }
    },
    async deleteImage(type, fileName) {
        try {
            const response = await instance.delete(`photos/${type}/${fileName}`);
            return response.data;
        } catch (error) {
            error.response.data.status >= 500 && console.log(error);  
            return error.response.data;
        }
    },
}